import React, { FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

import styles from './styles/pricing_content.module.scss';
import { Chip } from '../../components/chips/Chip';
import { useUser } from '../../user/useUser';

export const PricingContent: FC = () => {
  const {
    currentUser: { plan, expirationDate },
  } = useUser();

  const todayOrPast =
    moment().isSame(expirationDate) || moment().isAfter(expirationDate);
  const expire = todayOrPast ? 'Expiré depuis' : 'Expire';
  const date = moment(expirationDate).format('D MMMM YYYY');
  const conditionalSentencer = `${expire} le ${date}`;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p className={`${styles.header}__title`}>
          {plan === null ? 'Essai gratuit' : 'Abonnement'}
        </p>
        {expirationDate !== null && (
          <Chip color="secondary">{conditionalSentencer}</Chip>
        )}
      </div>
      <div className={classNames(styles.content, styles.mainContent)}>
        <p className={styles.speech}>
          <FormattedMessage id="components/button/pricing-button/PricingContent.tsx/1" />
        </p>
        <p className={styles.link}>
          <FormattedMessage id="components/button/pricing-button/PricingContent.tsx/2" />
        </p>
      </div>
    </div>
  );
};
